export default (sectionId, childId) =>
  new Promise((resolve, reject) => {
    window.axios
      .delete(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section/${sectionId}/children/${childId}`)
      .then(() => resolve())
      .catch((error) => {
        reject(error);
      });
  });
